import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../../config';

const baseUrl = config.baseUrl;
const organizacionesEndpoint = '/api/organizacionesSostenibilidad/';
const proyectosxorganizacionesEndpoint = '/api/proyectosPorOrganizacionSostenibilidad/';


// ✅ Crear una instancia de Axios
const api = axios.create({
    baseURL: baseUrl,
});

// ✅ Interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// 🔍 Obtener todas las organizaciones
export const getAllOrganizacionesSostenibilidad = async () => {
    try {
        const response = await axios.get(`${baseUrl}${organizacionesEndpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};



// 🔍 Obtener todas los proyectos por organización
export const getAllProyectosxOrganizacionesSostenibilidad = async (id_organizacion) => {
    try {
        const response = await axios.get(`${baseUrl}${proyectosxorganizacionesEndpoint}${id_organizacion}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
